import { BankOutlined, SettingOutlined } from '@ant-design/icons'
import { SystemsGrid } from '@components/Configurations/SystemsGrid'
import { TenantsGrid } from '@components/Configurations/TenantsGrid'
import { Vertical } from '@gravitate-js/excalibrr'
import { Tabs } from 'antd'
import React from 'react'

export function CrossroadsConfiguration() {
  const [activeTab, setActiveTab] = React.useState('tenants')

  const items = [
    { key: 'tenants', label: 'Tenants', icon: <BankOutlined /> },
    { key: 'systems', label: 'Systems', icon: <SettingOutlined /> },
  ]

  return (
    <Vertical>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        className='px-3 mb-2 rounded-sm border border-[var(--gray-300)]'
        style={{
          background: 'var(--bg-2)',
          flex: 1,
          marginBottom: 0,
        }}
        tabBarStyle={{
          marginBottom: 0,
          border: 'none',
        }}
        items={items}
      />
      {activeTab === 'tenants' && <TenantsGrid />}
      {activeTab === 'systems' && <SystemsGrid />}
    </Vertical>
  )
}
